import ComingSoon from "components/ComingSoon";
import React from "react";

const SmtpProfile = () => {
  return <ComingSoon />;
};

export default SmtpProfile;
